import { env } from '@/src/config/env'
import { DATA_LAYER_NAME } from '@/src/general/utils/gtm/constants'

import { toPascalCase } from '../../primitives/strings/toPascalCase'
import type { EVENTS } from './constants/Events.enum'
import type { TGTMEventObject, TGTMVariables } from './types/GTMVariables'

/**
 * Sends an event to the GTM dataLayer if the window is of type GTMEnhancedWindow.
 */
export const sendEvent = (
  /** The event to be sent to the dataLayer */
  event: EVENTS | TGTMEventObject,
  /** The variables associated with the event */
  variables: TGTMVariables = {},
  /** Flag to preserve the case of variables */
  preserveCase = false,
): void => {
  if (!(DATA_LAYER_NAME in window)) {
    // Handle the case where dataLayer is not defined
    if (env.NODE_ENV !== 'test') console.error('🛑 [GTM:sendEvent] - Add ReactTagManager.init passing GTM code in app ')
    return
  }
  if (typeof window[DATA_LAYER_NAME].push !== 'undefined') {
    const payload = {
      ...(typeof event === 'string' ? { event } : event),
      ...(preserveCase
        ? variables
        : Object.entries(variables || {}).reduce<Record<string, unknown>>((titleCasedVariables, [key, value]) => {
            titleCasedVariables[key] = typeof value === 'string' ? toPascalCase(value) : value
            return titleCasedVariables
          }, {})),
    }
    window[DATA_LAYER_NAME].push(payload)
    if (window?.react_gtm?.debug) {
      console.log('🟢 [GTM:sendEvent] send event with payload ', payload)
    }
  }
}
